import { Reducer } from 'redux';

import { SecurityState } from './types';

const defaultState: SecurityState = {
    accessTokensLoading: false,
};
const reducer: Reducer<SecurityState> = (state: SecurityState = defaultState, action): SecurityState => {
    const { payload } = action;
    switch (action.type) {
        case '@@security/FETCH_ACCESS_TOKENS':
        case '@@security/FETCH_ACCESS_TOKENS_ERROR':
        case '@@security/ADD_ACCESS_TOKEN':
        case '@@security/ADD_ACCESS_TOKEN_ERROR':
            return { ...state, ...{ accessTokensLoading: payload.accessTokensLoading } };
        case '@@security/FETCH_ACCESS_TOKENS_SUCCESS':
        case '@@security/ADD_ACCESS_TOKEN_SUCCESS':
            return {
                ...state,
                ...{ accessTokensLoading: payload.accessTokensLoading },
                ...{ accessTokens: payload.accessTokens },
            };
        case '@@security/UPDATE_ACCESS_TOKEN_SUCCESS':
            return {
                ...state,
                ...{ accessTokens: payload.accessTokens },
            };
        case '@@security/SHOW_ACCESS_TOKEN_CREDENTIALS':
            return {
                ...state,
                ...{ dialogCredentials: payload },
            };
        case '@@security/HIDE_ACCESS_TOKEN_CREDENTIALS':
            return {
                ...state,
                ...{ dialogCredentials: null },
            };
        case '@@security/DELETE_ACCESS_TOKEN':
        case '@@security/DELETE_ACCESS_TOKEN_SUCCESS':
        case '@@security/DELETE_ACCESS_TOKEN_ERROR':
        case '@@security/UPDATE_ACCESS_TOKEN':
        case '@@security/UPDATE_ACCESS_TOKEN_ERROR':
        case '@@security/CHANGE_ACCESS_TOKEN':
        case '@@security/CHANGE_ACCESS_TOKEN_SUCCESS':
        case '@@security/CHANGE_ACCESS_TOKEN_ERROR':
        default:
            return state;
    }
};

export { reducer as security };

export default reducer;
